import React from 'react';
import { DetailCheckAllProps } from './DetailCheckAll';
import { WeaCheckbox } from 'ecCom';
import { observer } from 'mobx-react';
import { isDragula } from '../../../../util/cubeUtil';

@observer
export default class DetailCheckbox extends React.Component<DetailCheckAllProps, any> {
    render() {
        const { card, detail, form, excel } = this.props;
        const bindObj = form.$('checkbox');
        let viewAttr = card.params.type == '1' || card.params.type == '2'  ? 2 : 1;
        const { isCopy = false, isDelete = false } = excel.detailProps;
        if (detail && card.detailMap[detail] && card.detailMap[detail][`row_${form.key}`]) {
            const { disableCheck } = card.detailMap[detail][`row_${form.key}`];
            if (disableCheck === true)  //隐藏明细
                viewAttr = 1;
        }
        if (!isDelete && form.value.dtl_id) {
            //不允许删除已有明细
            viewAttr = 1;
        }
        if(card.params.type == '0' && (isCopy ||isDelete)){ //显示布局下。允许快速编辑，开启删除或者复制功能允许勾选
            viewAttr = 2;
        }
        const checkId = "_" + detail + "_" + (form.key || "");
        let isDrag=isDragula(card,detail);
        if(isDrag){
            return <div>
                        <span style={{marginRight:5}}
                        data-index={form.key}
                        key={form.key}
                        className="icon-coms-move cursor-pointer"
                    />
                    <WeaCheckbox
                        {...bindObj.bind()}
                        fieldName={checkId}
                        viewAttr={viewAttr}
                    />
                </div>
        }else{
            return (
                <WeaCheckbox
                    {...bindObj.bind()}
                    fieldName={checkId}
                    viewAttr={viewAttr}
                />
            )
        }
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/checkbox-element/DetailCheckbox.tsx